import * as React from 'react';
import { observer } from 'mobx-react';
import autobind from "autobind-decorator";
import * as uuid from 'uuid';
import { observable } from 'mobx';
import { Button } from 'antd';

import { PaxOccupancyView, SearchType } from 'src/app/products/contractSimulator/parts/pax-occupancy.view';

interface OccupanciesComponentProps {
	values?: string;
	label?: string;
	searchType: SearchType;
	onValuesChange: (values: string) => void;
	mode: ControlMode;
	onlyOne?: boolean;
	initial?: { name: string, age: number }[];
}

interface OccupanciesComponentState {
	values: any;
}

interface SingleOccupancyProps {
	paxes: any[];
	occupancies: any[];
	onDeleteComplete: () => void;
	onDelete: (paxes: PersonOccupancy[], occupancies: Occupancy[]) => void;
	onEdit: (paxes: PersonOccupancy[], occupancies: Occupancy[]) => void;
	searchType: SearchType;
	mode: ControlMode;
	onlyOne?: boolean;
}

@observer
export class SingleOccupancyComponent extends React.Component<SingleOccupancyProps, any>{

	@observable
	private occupancies: Occupancy[] = [];

	@observable
	private paxes: PersonOccupancy[] = [];

	public componentDidMount() {
		this.paxes = this.props.paxes;
		this.occupancies = this.props.occupancies;
	}

	public componentWillReceiveProps(nextProps: Readonly<SingleOccupancyProps>) {
		if (this.props.paxes != nextProps.paxes) {
			this.paxes = nextProps.paxes;
			this.occupancies = nextProps.occupancies;
		}
	}

	public render() {
		return (
			<div style={{ marginBottom: '20px' }}>
				{!this.props.onlyOne && <Button disabled={this.props.mode == 'display'} icon='delete' onClick={() => {
					this.props.onDeleteComplete();
				}} />}
				<PaxOccupancyView
					paxs={this.paxes}
					occupancies={this.occupancies}
					type={this.props.searchType}
					setBusy={e => { }}
					onEdit={() => this.props.onEdit(this.paxes, this.occupancies)}
					onDelete={() => this.props.onDelete(this.paxes, this.occupancies)}
				/>
			</div>
		);
	}
}

@observer
export class OccupanciesComponent extends React.Component<OccupanciesComponentProps, OccupanciesComponentState> {
	constructor(props) {
		super(props);

		this.state = {
			values: [],
		};
	}

	public componentDidMount() {
		const values: { paxes: any[], occupancies: any[] }[] = this.props.values ? this.decoupleValues(this.props.values) : [];

		this.setState({ values });

		if (values.length == 0 && this.props.onlyOne) {
			this.addNewOccupancy();
		}
	}

	encodeValues(values: any) {
		console.log(values)
		return JSON.stringify(values);
	}

	@autobind
	async encodeAndNotify(): Promise<any> {
		this.props.onValuesChange(this.encodeValues(this.state.values));
	}

	editInter = (index: number, paxes: any[], occupancies: any[]) => {
		this.state.values[index] = { paxes, occupancies };
		this.encodeAndNotify();
	}

	decoupleValues(values: string): { paxes: any[], occupancies: any[] }[] {
		return JSON.parse(values);
	}

	addNewOccupancy = () => {
		const value = { paxes: [], occupancies: [] };

		value.paxes.splice(0, value.paxes.length);

		const initial = this.props.initial || [
			{ name: "Adult 1", age: 30 },
			{ name: "Adult 2", age: 30 },
			{ name: "Youth 1", age: 15 },
			{ name: "Youth 2", age: 15 },
			{ name: "Child 1", age: 10 },
			{ name: "Child 2", age: 10 },
			{ name: "Infant 1", age: 1 },
			{ name: "Infant 2", age: 1 },
		];

		for (const param of initial) {
			value.paxes.push({ name: param.name, age: param.age, id: uuid.v4() });
		}

		value.occupancies.push({ unit: 1, paxs: value.paxes.map(x => x) });

		const overAll = this.state.values;

		overAll.push(value);

		this.setState({ values: overAll }, this.encodeAndNotify);
	}

	render() {
		return (
			<React.Fragment>
				<h4>{this.props.label}</h4>
				{
					this.state.values.map((occ, index) => (
						<SingleOccupancyComponent
							key={'occ' + index}
							paxes={occ.paxes}
							mode={this.props.mode}
							searchType={this.props.searchType}
							onDelete={(paxes, occ) => this.editInter(index, paxes, occ)}
							onEdit={(paxes, occ) => this.editInter(index, paxes, occ)}
							onlyOne={this.props.onlyOne}
							onDeleteComplete={() => {
								this.state.values.splice(index, 1);
								this.encodeAndNotify();

								this.setState({ values: [...this.state.values] })
							}}
							occupancies={occ.occupancies}
						/>
					))
				}
				{!this.props.onlyOne && <Button disabled={this.props.mode == 'display'} onClick={this.addNewOccupancy} icon='plus'></Button>}
			</React.Fragment>);
	}
}



// WEBPACK FOOTER //
// ./src/app/rules/rules/form/parts/executors/parts/occupancies-component.tsx